const directions = {
  UP: 'UP',
  DOWN: 'DOWN'
};

class ScrollObserver {

  constructor({ direction = directions.DOWN, actionableZoneFromTop = 50, actionableZoneFromBottom = 50, callback }) {

    this.scrollProcessor = this.getScrollProcessor({ direction, actionableZoneFromTop, actionableZoneFromBottom, callback });

    this.callback = this.callback.bind(this);

  }

  getScrollProcessor({ direction, actionableZoneFromTop, actionableZoneFromBottom, callback }) {

    if (direction === directions.UP) {
      return new UpScrollProcessor(actionableZoneFromBottom, callback);
    }

    return new DownScrollProcessor(actionableZoneFromTop, callback);

  }

  callback(event) {

    const element = event.target;

    this.scrollProcessor.tryNotify(element);

  }

}

class ScrollProcessor {

  constructor(distance, callback) {

    this.currentScrollTop = 0;
    this.calledAt = Date.now();
    this.callback = callback;
    this.distance = distance;

  }

  getScrollDirection(scrollTop) {

    const previousScrollTop = this.currentScrollTop;
    this.currentScrollTop = scrollTop;

    if (previousScrollTop > this.currentScrollTop) {
      return directions.UP;
    } else {
      return directions.DOWN;
    }

  }

  tryNotify(element) {

    const previousScrollTop = this.currentScrollTop;
    const scrollTop = element.scrollTop;
    const clientHeight = element.clientHeight;
    const scrollHeight = element.scrollHeight;

    const previouslyCalledAt = this.calledAt;
    const now = Date.now();

    if (this.getScrollDirection(scrollTop) !== this.direction) {

      return;
    }

    if ((now - previouslyCalledAt) < 100) {
      return;
    }

    const notify = this.canNotify(element, { previousScrollTop, scrollTop, clientHeight, scrollHeight });

    if (notify === false) {
      return;
    }

    this.callback();
    this.calledAt = now;

  }

}

class UpScrollProcessor extends ScrollProcessor {

  constructor(distance, callback) {
    super(distance, callback);
    this.direction = directions.UP;
  }

  canNotify(element, { previousScrollTop, scrollTop, clientHeight, scrollHeight }) {

    if (scrollTop > this.distance) {
      return false;
    }

    return true;

  }

}

class DownScrollProcessor extends ScrollProcessor {

  constructor(distance, callback) {
    super(distance, callback);
    this.direction = directions.DOWN;
  }

  canNotify(element, { previousScrollTop, scrollTop, clientHeight, scrollHeight }) {

    if ((scrollTop + this.distance + clientHeight) < scrollHeight) {
      return false;
    }

    return true;

  }

}

ScrollObserver.directions = directions;

export default ScrollObserver;